<div style="padding-top: 10px; margin-left: -15px">
      <angular-file-uploader [config]="afuConfig" (ApiResponse)="DocUpload($event)"></angular-file-uploader>
      <!-- <ngb-rating [(rate)]="value" (rateChange)="valueChange.emit($event)" [readonly]="disabled"></ngb-rating> -->
</div>
